import { render, staticRenderFns } from "./payinfo.vue?vue&type=template&id=5d18a784&scoped=true"
import script from "./payinfo.vue?vue&type=script&lang=js"
export * from "./payinfo.vue?vue&type=script&lang=js"
import style0 from "./payinfo.vue?vue&type=style&index=0&id=5d18a784&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18a784",
  null
  
)

export default component.exports